export const sizes = {
  xs: "text-xs h-8 px-3.5 rounded-md -tracking-[0.008rem]",
  sm: "text-xs h-9 px-4 rounded-md -tracking-[0.008rem]",
  md: "text-sm h-10 px-4.5 rounded-lg -tracking-[0.009rem]",
  lg: "text-sm h-11 px-5.5 rounded-lg -tracking-[0.009rem]",
};

export const startLoadingPaddings = {
  xs: "pl-[32px]",
  sm: "pl-[34px]",
  md: "pl-[37px]",
  lg: "pl-[40px]",
} as const;

export const endLoadingPaddings = {
  xs: "pr-[26px]",
  sm: "pr-[28px]",
  md: "pr-[37px]",
  lg: "pr-[40px]",
} as const;

export const variants = {
  primary:
    "text-chorus-gray-50 bg-chorus-black-300 disabled:text-chorus-gray-500 disabled:bg-chorus-gray-100",
  secondary:
    "text-chorus-black-500 bg-chorus-teal-200 disabled:text-chorus-gray-600",
  tertiary:
    "text-chorus-black-100 bg-chorus-gray-100 disabled:text-chorus-gray-500",
  outline:
    "border border-chorus-gray-200 text-chorus-black-300 bg-white disabled:text-chorus-gray-500 ",
  link: "text-chorus-teal-700 bg-transparent disabled:text-chorus-gray-500",
  transparent: "bg-transparent",
  white: "text-[#475569] bg-white disabled:text-[#94A3B8]",
};

export const spinnerSizes = {
  xs: "xxs",
  sm: "xxs",
  md: "xs",
  lg: "xs",
} as const;

export const spinnerPaddings = {
  xs: "p-[3px]",
  sm: "p-[3px]",
  md: "p-[4px]",
  lg: "p-[4px]",
};
